<div [ngSwitch]="fieldType">
  <div *ngSwitchCase="'TEXT'">{{fieldValue}}</div>
  <div *ngSwitchCase="'BOOLEAN'"><i class="{{ iconBoolean }}"></i></div>
  <div *ngSwitchCase="'NUMBER'">{{fieldValue}}</div>
  <div *ngSwitchCase="'EMAIL'">{{fieldValue}}</div>
  <div *ngSwitchCase="'CURRENCY'">{{(+fieldValue).toFixed(2)}}</div>
  <div *ngSwitchCase="'DATE'">{{parseMoment(fieldValue)}}</div>
  <div *ngSwitchCase="'UTCDATE'">{{parseMomentUtc(fieldValue)}}</div>
  <div *ngSwitchCase="'ICON'"><i class="{{ icon }}"></i></div>
  <div *ngSwitchCase="'AVATAR'">
    <nz-avatar nzSize="large" nzIcon="user" nzSrc="{{fieldValue}}"></nz-avatar>
  </div>
  <div *ngSwitchCase="'CHECK'">
    <i [ngClass]="{
      'icmn-checkbox-checked': fieldValue,
      'icmn-checkbox-unchecked': !fieldValue
    }"></i>
  </div>
  <div *ngSwitchCase="'THUMBNAIL'">
    <a href="javascript: void(0);" class="cat__ecommerce__dashboard__list__img">
      <img src="{{fieldValue}}" />
    </a>
  </div>
  <div *ngSwitchCase="'CHECK_THUMBNAIL'">
    <a *ngIf="fieldValue[0]" href="javascript: void(0);" class="thumbnail__list__img">
      <img src="{{fieldValue[1]}}" />
    </a>
    <a *ngIf="!fieldValue[0]" href="javascript: void(0);" class="thumbnail__list__img">
      <img src="{{fieldValue[1]}}" style="opacity: 0.5;" />
    </a>
  </div>
  <div *ngSwitchDefault>{{fieldValue}}</div>
</div>
